import hyphenateStyleName from"hyphenate-style-name";export default function hyphenateProperty(property){return hyphenateStyleName(property)}